import React from "react";
import {
    MapPin,
    AlertTriangle,
    Users,
    Phone,
    BookOpen,
    Clock,
    Search,
    RotateCcw,
    Power,
    CreditCard,
    Bell,
    Baby,
    User,
    Building,
    Sunset,
    Shield,
    TrendingUp,
    PhoneOff,
    Smile,
    Ban,
    Utensils,
    LocateFixed,
    Sofa,
    Factory,
    Briefcase,
    GraduationCap,
    UserX,
    Laptop,
    Puzzle,
    Moon,
    Bed,
    VolumeX,
    Theater,
    Coffee,
    Home,
    Gift,
    Gamepad2,
    Heart,
    Calendar,
    Pill,
    Flower2,
    Lock,
    Trophy,
    Star,
    Check,
} from "lucide-react";

const iconMap: Record<string, React.FC<{ className?: string }>> = {
    MapPin,
    AlertTriangle,
    Users,
    Phone,
    BookOpen,
    Clock,
    Search,
    RotateCcw,
    Power,
    CreditCard,
    Bell,
    Baby,
    User,
    Building,
    Sunset,
    Shield,
    TrendingUp,
    PhoneOff,
    Smile,
    Ban,
    Utensils,
    LocateFixed,
    Sofa,
    Factory,
    Briefcase,
    GraduationCap,
    UserX,
    Laptop,
    Puzzle,
    Moon,
    Bed,
    VolumeX,
    Theater,
    Coffee,
    Home,
    Gift,
    Gamepad2,
    Heart,
    Calendar,
    Pill,
    Flower2,
    Lock,
    Trophy,
    Star,
    Check,
};

export const getIconByKey = (key: string, className?: string): React.ReactNode => {
    const Icon = iconMap[key];
    if (!Icon) return null;
    return <Icon className={className} />;
};

export default iconMap;
